import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHeart,
  faBolt,
  faStar,
  faArrowRight,
  faQuoteLeft,
  faChildReaching,
} from '@fortawesome/free-solid-svg-icons';

const groups = [
  {
    icon: faChildReaching,
    title: 'GC de Crianças',
    description: 'Um espaço especial para os pequenos crescerem na fé, aprenderem sobre Jesus e fazerem amigos de verdade.',
    tag: 'Para os pequeninos',
    color: 'text-purple-400',
    bg: 'bg-purple-500/8',
    border: 'border-purple-500/20',
  },
  {
    icon: faHeart,
    title: 'GC de Mulheres',
    description: 'Um espaço seguro para mulheres se conectarem, estudarem a Palavra e se encorajarem mutuamente.',
    tag: 'Espaço seguro',
    color: 'text-pink-400',
    bg: 'bg-pink-500/8',
    border: 'border-pink-500/20',
  },
  {
    icon: faBolt,
    title: 'GC de Jovens',
    description: 'Para a galera que quer viver o Evangelho com profundidade, autenticidade e comunidade real.',
    tag: 'Energia & propósito',
    color: 'text-blue-400',
    bg: 'bg-blue-500/8',
    border: 'border-blue-500/20',
  },
  {
    icon: faStar,
    title: 'GC de Homens',
    description: 'Para homens que buscam responsabilidade, caráter e amizades que edificam dentro e fora de casa.',
    tag: 'Caráter & liderança',
    color: 'text-emerald-400',
    bg: 'bg-emerald-500/8',
    border: 'border-emerald-500/20',
  },
];

const howItWorks = [
  { step: '01', title: 'Escolha um grupo', desc: 'Encontre o GC mais próximo de você ou que se encaixa no seu perfil.' },
  { step: '02', title: 'Entre em contato', desc: 'Fale com o líder do grupo e confirme sua participação.' },
  { step: '03', title: 'Apareça', desc: 'Venha do jeito que você é. Seja bem-vindo à comunidade.' },
];

const GrowthGroups = () => {
  return (
    <section id="gcs" className="py-24 bg-[#0d1526]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Cabeçalho */}
        <div className="text-center mb-16">
          <div className="section-label mx-auto w-fit">Comunidade</div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">
            Grupos de <span className="text-gradient">Crescimento</span>
          </h2>
          <p className="text-gray-500 mt-3 max-w-xl mx-auto">
            Os GCs são pequenos grupos que se reúnem durante a semana para estudar a Bíblia, orar juntos e fazer amizades de verdade.
          </p>
        </div>

        {/* Cards de grupos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
          {groups.map(({ icon, title, description, tag, color, bg, border }) => (
            <div
              key={title}
              className={`glass-card card-shine rounded-2xl p-6 border ${border} flex flex-col group hover:bg-white/5 transition-all duration-300 hover:-translate-y-1`}
            >
              <div className={`${bg} w-12 h-12 rounded-xl flex items-center justify-center mb-5`}>
                <FontAwesomeIcon icon={icon} className={`${color} text-lg`} />
              </div>
              <span className={`text-xs font-bold uppercase tracking-wider ${color} mb-2`}>{tag}</span>
              <h3 className="text-white font-bold text-lg mb-3">{title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed flex-grow">{description}</p>
            </div>
          ))}
        </div>

        {/* Citação */}
        <div className="glass-card rounded-2xl p-8 md:p-12 mb-20 relative overflow-hidden">
          <div className="absolute top-6 left-8 text-yellow-500/10">
            <FontAwesomeIcon icon={faQuoteLeft} className="text-7xl" />
          </div>
          <p className="relative text-gray-300 text-lg md:text-xl italic text-center max-w-3xl mx-auto leading-relaxed">
            "Os GCs são o coração da nossa igreja. É onde você deixa de ser um rosto na multidão e passa a ser parte de uma família."
          </p>
        </div>

        {/* Como funciona */}
        <div className="mb-16">
          <h3 className="text-center text-2xl font-bold text-white mb-10">
            Como <span className="text-gradient">funciona</span>?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {howItWorks.map(({ step, title, desc }) => (
              <div key={step} className="flex gap-5 items-start">
                <span className="text-4xl font-extrabold text-yellow-500/20 leading-none mt-1 select-none">
                  {step}
                </span>
                <div>
                  <h4 className="text-white font-semibold mb-1">{title}</h4>
                  <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="https://wa.me/5584996632025"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-gray-900 px-8 py-4 rounded-xl text-base font-bold transition-all duration-200 shadow-lg shadow-yellow-500/20 hover:shadow-yellow-400/30 hover:-translate-y-0.5"
          >
            Quero participar de um GC
            <FontAwesomeIcon icon={faArrowRight} className="text-sm" />
          </a>
          <p className="text-gray-600 text-sm mt-4">
            Fale com a gente pelo WhatsApp e te conectamos ao grupo ideal para você.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GrowthGroups;
